import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import config from '../../config';
import { updateAvatar } from '../../redux/actions/AuthActions';
import { CameraOutlined, UserOutlined } from '@ant-design/icons';
import { Spin, Avatar } from 'antd';

// const { URL_ASSET } = config;

function UploadAvatar(props) {
  const user = useSelector((state) => state.auth.authUser);
  const dispatch = useDispatch();
  const [imgSrc, setImgSrc] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setImgSrc(user?.image);
  }, [user]);

  const handleImageUpdate = async (event) => {
    var file = event.target.files[0];

    let formD = new FormData();
    formD.append('image', file);
    setLoading(true);
    try {
      dispatch(updateAvatar(user.id, formD));
    } catch (error) {
      console.error('Error updating avatar:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      {loading ? (
        <div className="container-avatar">
          <img src={imgSrc} alt="Avatar" className="image-avatar-loading" />
          <div className="middle-avatar-loading">
            <div className="text-avatar">
              <Spin />
            </div>
          </div>
        </div>
      ) : (
        <div className="container-avatar">
          {imgSrc ? (
            <Avatar size={64} src={imgSrc} />
          ) : (
            <Avatar size={64} icon={<UserOutlined />} />
          )}
          <div className="middle-avatar">
            <div className="text-avatar">
              <label htmlFor="upload-btn-avatar" style={{ cursor: 'pointer' }}>
                <CameraOutlined />
              </label>
              <input
                type="file"
                id="upload-btn-avatar"
                accept="image/*"
                name="avatar"
                className="d-none"
                onChange={handleImageUpdate}
              />
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default UploadAvatar;
